module.exports = __webpack_public_path__ + "static/media/BPM.a52d6ac0.jpg";